import {
    Box,
    chakra,
    Container,
    Stack,
    Text,
    useColorModeValue,
    useBreakpointValue,
    VisuallyHidden,
} from '@chakra-ui/react';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';
// eslint-disable-next-line no-unused-vars
import { Link as RouterLink } from 'react-router-dom';
import Flag from './images/flag.png';
import Lion from './images/lion.webp';
import PlayStoreBadge from './images/androidBadge.png';

const SocialButton = ({
    children,
    label,
    href,
}) => {
    return (
        <chakra.button
            bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
            rounded={'full'}
            w={8}
            h={8}
            cursor={'pointer'}
            as={'a'}
            href={href}
            display={'inline-flex'}
            alignItems={'center'}
            justifyContent={'center'}
            transition={'background 0.3s ease'}
            _hover={{
                bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
            }}>
            <VisuallyHidden>{label}</VisuallyHidden>
            {children}
        </chakra.button>
    );
};

export default function SmallCentered() {

    const onButtonClick = () => {
        // using Java Script method to get PDF file
        fetch('app-debug.apk').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'app-debug.apk';
                alink.click();
            })
        })
    }
    return (
        <Box
            bg={useColorModeValue('gray.50', 'gray.900')}
            color={useColorModeValue('gray.700', 'gray.200')}>
            <Container
                as={Stack}
                maxW={'6xl'}
                py={4}
                spacing={4}
                wrap={'wrap'}
                direction={'row'}
                justify={'space-between'}
                align={'center'}>
                <Box
                    style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <Text
                        textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
                        fontFamily={'heading'}
                        fontSize={'lg'}
                        color={useColorModeValue('yellow.700', 'white')}
                        style={{ position: 'relative', left: '25px' }}
                    >
                        Festin-o-Beats 12.0
                    </Text>
                    <img src={Flag} style={{ width: '100%', position: 'absolute', left: '25px', opacity: '0.3' }} alt="Flag" />
                    <img src={Lion} style={{ width: '100%', position: 'absolute', left: '-20px', top: '-25px', opacity: '0.9' }} alt="Flag" />
                </Box>

                <Stack direction={'row'} spacing={6}>
                    <SocialButton label={'Facebook'} href={'https://www.facebook.com/abesit.in'}>
                        <FaFacebook />
                    </SocialButton>
                    <SocialButton label={'YouTube'} href={'https://www.linkedin.com/school/abesit-college-of-engineering/'}>
                        <FaLinkedin />
                    </SocialButton>
                    <SocialButton label={'Instagram'} href={'https://www.instagram.com/abesit_ghaziabad/'}>
                        <FaInstagram />
                    </SocialButton>
                </Stack>
                <Stack align={'flex-start'} direction='column'>
                    <Box width={{ base: '100px', md: '200px' }}>

                        <button onClick={onButtonClick}>
                            <img src={PlayStoreBadge} alt="PlayStore" />
                        </button>
                    </Box>
                </Stack>
            </Container>

            {/* <Box
                borderTopWidth={1}
                borderStyle={'solid'}
                borderColor={useColorModeValue('gray.200', 'gray.700')}>
                <Container
                    as={Stack}
                    maxW={'6xl'}
                    py={4}
                    direction={{ base: 'column', md: 'row' }}
                    spacing={4}
                    justify={{ base: 'center', md: 'space-between' }}
                    align={{ base: 'center', md: 'center' }}>
                    <Text>Made By:- Aftab Ahmed &amp; Shivam Sharma</Text>

                </Container>
            </Box> */}
        </Box>
    );
}